import React, {useState} from 'react'
import { Plane, Repeat, ArrowLeftRight } from "lucide-react"
import Stretch from '../../models/Stretch'
import {useTranslation} from 'react-i18next'

interface Props {
  trayecto: Stretch
  sentidoOrigen: boolean
  idaVuelta: boolean
  handleChangeOpcionVuelta: (e: {target: {value: string}}) => void
  handleSentido: () => void
}

export const VueltaViceversaView: React.FC<Props> = ({
                                                       trayecto,
                                                       sentidoOrigen,
                                                       idaVuelta,
                                                       handleChangeOpcionVuelta,
                                                       handleSentido,
                                                     }) => {

  const [selected, setSelected] = useState<string>('soloIda')
  const {t} = useTranslation('global')

  return (
    <div className="w-full flex flex-col gap-6 p-4 bg-white rounded-2xl shadow-md row row-cols-auto text-left">
      {/* Selección Ida / Ida y vuelta */}
      <div className="flex gap-4 w-full">
        {idaVuelta && (
          <button
            onClick={() => {
              setSelected('soloIda')
              handleChangeOpcionVuelta({target: {value: "soloIda"}})
            }
            }
            className={`px-5 py-2 rounded-xl border transition-all duration-200 flex items-center gap-2
              ${
              selected === 'soloIda'
                ? "bg-blue-600 text-white border-blue-600 shadow"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200 border-gray-300"
            }
              disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            <Plane size={18} />
            <span>{t('singleJourney')}</span>
          </button>
        )}

        {idaVuelta && (
          <button
            onClick={() => {
              setSelected('idaVuelta')
              handleChangeOpcionVuelta({target: {value: "idaVuelta"}})
            }
            }
            className={`px-5 py-2 rounded-xl border transition-all duration-200 flex items-center gap-2
              ${
              selected === 'idaVuelta'
                ? "bg-blue-600 text-white border-blue-600 shadow"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200 border-gray-300"
            }
              disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            <Repeat size={30} />
            <span>{t('roundTrip')}</span>
          </button>
        )}
      </div>

      {/* Origen / Destino */}
      {trayecto.origin && trayecto.destination && (
        <div className="grid grid-cols-3 items-center gap-6">
          <div className="text-center px-2">
            <strong><p className="text-xl text-blue-t1">Origen</p></strong>
            <p className="font-semibold text-lg text-blue-t0">
              {sentidoOrigen ? trayecto.origin : trayecto.destination}
            </p>
          </div>
          <div className="flex justify-center">
            <button
              onClick={handleSentido}
              className="p-3 rounded-full border bg-blue-50 text-blue-600 hover:bg-blue-100 transition-all"
            >
              <ArrowLeftRight size={30} />
            </button>
          </div>

          <div className="text-center px-2">
            <strong><p className="text-xl text-blue-t1">Destino</p></strong>
            <p className="font-semibold text-lg text-blue-t0">
              {sentidoOrigen ? trayecto.destination : trayecto.origin}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
